import { sanitizeErrorMessage } from '@exodus/errors';
import { isNumberUnit } from '@exodus/currency';
import { cloneDeepWith } from 'lodash';
const toJSON = (error) => {
    const serializedDetails = error.details
        ? cloneDeepWith(error.details, (val) => {
            if (val && isNumberUnit(val))
                return val.toDefaultString({ unit: true });
            if (typeof val === 'string')
                return sanitizeErrorMessage(val);
        })
        : null;
    return {
        name: error.name,
        message: sanitizeErrorMessage(error.message),
        ...(serializedDetails ? { details: serializedDetails } : {}),
        ...(process.env.NODE_ENV === 'test'
            ? {}
            : { stack: sanitizeErrorMessage(error.cause?.stack || error.stack) }),
    };
};
export class ExchangeError extends Error {
    name = 'ExchangeError';
    isExchange = true;
    details;
    constructor({ message, details }, opts) {
        super(message, opts);
        this.details = details;
    }
    toJSON = () => toJSON(this);
}
export class CreateOrderError extends ExchangeError {
    name = 'CreateOrderError';
    orderId;
    constructor({ message, orderId, details, }, opts) {
        super({ message, details }, opts);
        this.orderId = orderId;
    }
}
export class GetProviderOrderError extends ExchangeError {
    name = 'GetProviderOrderError';
}
export class OrderValidationError extends ExchangeError {
    name = 'OrderValidationError';
    constructor({ message, order, providerOrder }, opts) {
        const details = {
            order,
            providerOrder,
        };
        super({ message, details }, opts);
    }
}
export class CreateTxError extends ExchangeError {
    name = 'CreateTxError';
}
export class CreateDexTxError extends ExchangeError {
    name = 'CreateTxError';
}
export class SendTxError extends ExchangeError {
    name = 'SendTxError';
}
export class SignTxError extends ExchangeError {
    name = 'SignTxError';
}
export class GetAllowanceError extends ExchangeError {
    name = 'GetAllowanceError';
    constructor({ message, assetId, approvalAddress, }, opts) {
        const details = {
            assetId,
            approvalAddress,
        };
        super({ message, details }, opts);
    }
}
export class ApproveTokensError extends ExchangeError {
    name = 'ApproveTokensError';
    constructor({ message, assetId, approvalAddress, amount, }, opts) {
        const details = {
            assetId,
            approvalAddress,
            amount: amount.toDefaultString(),
        };
        super({ message, details }, opts);
    }
}
